import CustomerDateOfBirthUpdateForm from '../components/CustomerDateOfBirthUpdateForm'
import CustomerDeleteProfileForm from '../components/CustomerDeleteProfileForm'
import CustomerEmailUpdateForm from '../components/CustomerEmailUpdateForm'
import CustomerNameUpdateForm from '../components/CustomerNameUpdateForm'
import CustomerPasswordUpdateForm from '../components/CustomerPasswordUpdateForm'
import CustomerPhoneNumberUpdateForm from '../components/CustomerPhoneNumberUpdateForm'
import MarketingConsents from '../components/MarketingConsents'

import styles from './ProfileDetails.module.scss'

const ProfileDetails = () => {
  return (
    <div>
      <div className={styles.title} id='profile_details_my_data'>
        Moje dane
      </div>
      <CustomerNameUpdateForm />
      <CustomerDateOfBirthUpdateForm />
      <CustomerPhoneNumberUpdateForm />
      <CustomerEmailUpdateForm />
      <CustomerPasswordUpdateForm />
      <CustomerDeleteProfileForm />
      <MarketingConsents />
    </div>
  )
}

export default ProfileDetails
